import React from "react";
import Image from "next/image";
import {
  FiDollarSign,
  FiHome,
  FiMapPin,
  FiRepeat,
  FiShield,
  FiSun,
  FiTruck,
  FiBox,
} from "react-icons/fi";

const Card = () => {
  return (
    <ul className="my-0">
      <li className="flex items-center py-3">
        <span className="text-xl text-gray-400 items-start mr-4">
          <FiTruck />
        </span>
        <p className="font-sans leading-5 text-sm text-gray-500">
          Free shipping apply to all orders over shipping{" "}
          <span className="font-semibold">৳1000 </span>
        </p>
      </li>
      <li className="flex items-center py-3">
        <span className="text-xl text-gray-400 items-start mr-4">
          <FiHome />
        </span>
        <p className="font-sans leading-5 text-sm text-gray-500">
          Home Delivery within <span className="font-semibold">1-3 days </span>
          within city areas
        </p>
      </li>
      <li className="flex items-center py-3">
        <span className="text-xl text-gray-400 items-start mr-4">
          <FiDollarSign />
        </span>
        <p className="font-sans leading-5 text-sm text-gray-500">
          Cash on Delivery Available Nationwide
        </p>
      </li>
      <li className="flex items-center py-3">
        <span className="text-xl text-gray-400 items-start mr-4">
          <FiShield />
        </span>
        <p className="font-sans leading-5 text-sm text-gray-500">
        <span className="font-semibold">7</span> Days replacement
          guarantee
        </p>
      </li>
      <li className="flex items-center py-3">
        <span className="text-xl text-gray-400 items-start mr-4">
          <FiSun />
        </span>
        <p className="font-sans leading-5 text-sm text-gray-500">
          Guaranteed 100% original product from manufacturing brand.
        </p>
      </li>
      <li className="flex items-center py-3">
        <span className="text-xl text-gray-400 items-start mr-4">
          <FiMapPin />
        </span>
        <p className="font-sans leading-5 text-sm text-gray-500">
          Delivery from Dhaka Warehouse in Pallabi.
        </p>
      </li>
      <li className="flex items-center py-3">
        <span className="text-xl text-gray-400 items-start mr-4">
          <FiBox />
        </span>
        <p className="font-sans leading-5 text-sm text-gray-500">
          <a href="https://www.cubenationshop.com/shipping-and-returns/">Click here for Shipping and return details</a>
        </p>
      </li>
      <li className="px-1 mb-2 md:mb-0 transition hover:opacity-80 inline-flex hidden">
                      <Image
                        width={274}
                        height={85}
                        className="w-full"
                        src="/payment-method/payment-logo.png"
                        alt="payment method"
                        placeholder="blur"
                        blurDataURL="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                        style={{
                          maxWidth: "100%",
                          height: "auto"
                        }} />
     </li>
        
    </ul>
  );
};

export default Card;
